// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"04c3ac96","249":"753ac88d","386":"6531a9b4","402":"683b90e9","438":"431a1c7a","458":"123952a4","498":"327451ce","502":"c9da7609","596":"2b342200","705":"fea225a2","897":"c921e725","924":"d7fb2af7","937":"8bbf8ab0"}[chunkId] + ".chunk.js";
};